module.exports = __webpack_public_path__ + "static/media/20170617-200601-013.7422b59d.png";